import { c as _c } from "react/compiler-runtime";
import type { CentralIconBaseProps } from '@central-icons-react/round-outlined-radius-2-stroke-2/CentralIconBase';
import type { ComponentType, CSSProperties } from 'react';
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
type IconSize = 16 | 24 | 40;

// Central draws on a 24px grid and scales its stroke with the icon; we keep our fixed px
// weights instead. The rule that applies it lives in packages/ui tailwind.css.
const strokeBySize: Record<IconSize, number> = {
  16: 1.5,
  24: 2,
  40: 3
};
type Options = {
  // For a Central glyph that fills its box differently from ours and has no Small/Medium/Large
  // sibling to switch to. The stroke is divided back so the weight stays at our px value.
  scale?: number;
};
export const createCentralIcon = (Icon: ComponentType<CentralIconBaseProps>, size: IconSize, {
  scale
}: Options = {}) => {
  const CentralIcon = t0 => {
    const $ = _c(8);
    const {
      "aria-label": ariaLabel,
      className,
      color
    } = t0;
    let t1;
    if ($[0] !== color) {
      t1 = color ? getIconColor(color) : undefined;
      $[0] = color;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const t2 = !ariaLabel;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        flexShrink: 0,
        "--central-icon-stroke": `${strokeBySize[size] / (scale ?? 1)}px`,
        ...(scale ? {
          transform: `scale(${scale})`
        } : {})
      };
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    let t4;
    if ($[3] !== ariaLabel || $[4] !== className || $[5] !== t1 || $[6] !== t2) {
      t4 = <Icon size={size} color={t1} ariaHidden={t2} aria-label={ariaLabel} role="img" className={className} data-colored={false} data-central-icon="" style={t3 as CSSProperties} />;
      $[3] = ariaLabel;
      $[4] = className;
      $[5] = t1;
      $[6] = t2;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    return t4;
  };
  return CentralIcon;
};